import NtwOptions from "./NtwRightPanel/NtwOptions";
import NtwContentHeader from "./NtwRightPanel/NtwContentHeader";
import NtwFinish from "./NtwRightPanel/NtwFinish";

//this component will re-render every time an option is selected
export default function NtwRightPanel({toggle}) {
  return (
    <div className="ntw-right-panel-outer-content">
      <div className="ntw-right-panel-inner-content">
        <NtwContentHeader/>
        <NtwOptions/>
        <NtwFinish toggle={toggle}/>
      </div>
    </div>
  )
}